import resizeContainerComponent from './component.vue'

const ResizeContainer = {
    install: function(Vue) {
        Vue.component('ResizeContainer', resizeContainerComponent)
    }
}
export default ResizeContainer
